import { constants as questionnarieActions } from "../questionnaire/actions";
import { constants as questionnarieViewActions } from "../questionnaireViewUpdate/actions";
import { constants as providersActions } from "../providers/actions";
import { constants as callReportActions } from "../callReports/actions";
import { constants as callTakersActions } from "../callTakers/actions";
import { constants as textBlastActions } from "../textBlasts/actions";
import { constants as returnCallActions } from "../returnCall/actions";
import { constants as briefingsActions } from "../briefings/actions";
import { constants as lessonActions } from "../lessons/actions";

const { UPDATE_QUESTIONNAIRE_FORM_FIELD } = questionnarieActions;
const { UPDATE_QUESTIONNAIRE_VIEW_UPDATE_FORM_FIELD, UPDATE_FORM } =
  questionnarieViewActions;
const { UPDATE_PROVIDER_FORM_FIELD, UPDATE_PROVIDER_LIST_FILTERS } =
  providersActions;
const { UPDATE_DATE_FILTER, UPDATE_CALL_REPORTS_FILTERS } = callReportActions;
const { UPDATE_USER_FORM_FIELD } = callTakersActions;
const { UPDATE_BLAST_FORM_FIELD } = textBlastActions;
const { UPDATE_RETURN_CALL_FORM_FIELD } = returnCallActions;
const { UPDATE_LESSON_FORM_FIELD } = lessonActions;
const { UPDATE_BRIEFING_FORM_FIELD } = briefingsActions;

/**
 * A list of action types that should be ignored and not sent to Sentry.
 * These actions typically involve form field updates and filter changes,
 * which are not critical for error tracking.
 *
 * @constant {string[]} actionsToIgnore
 */
export const actionsToIgnore = [
  UPDATE_QUESTIONNAIRE_FORM_FIELD,
  UPDATE_QUESTIONNAIRE_VIEW_UPDATE_FORM_FIELD,
  UPDATE_FORM,
  UPDATE_PROVIDER_FORM_FIELD,
  UPDATE_PROVIDER_LIST_FILTERS,
  UPDATE_DATE_FILTER,
  UPDATE_CALL_REPORTS_FILTERS,
  UPDATE_USER_FORM_FIELD,
  UPDATE_BLAST_FORM_FIELD,
  UPDATE_RETURN_CALL_FORM_FIELD,
  UPDATE_LESSON_FORM_FIELD,
  UPDATE_BRIEFING_FORM_FIELD,
];
